// components/ModaleConferma.js
import React from 'react';
import {
  Modal,
  ModalDialog,
  Typography,
  Button,
  ModalClose,
  Box,
} from '@mui/joy';

export default function ModaleConferma({ open, onClose, onConfirm, title, message }) {
  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog variant="outlined" role="alertdialog">
        <ModalClose />
        <Typography level="h4" mb={1}>
          {title || 'Sei sicuro?'}
        </Typography>
        <Typography mb={2}>
          {message || 'Questa azione non può essere annullata.'}
        </Typography>
        <Box display="flex" justifyContent="flex-end" gap={1}>
          <Button variant="plain" color="neutral" onClick={onClose}>
            Annulla
          </Button>
          <Button variant="solid" color="danger" onClick={onConfirm}>
            Continua
          </Button>
        </Box>
      </ModalDialog>
    </Modal>
  );
}
